export default function Car() {
  return (
    <div
      className="axa-icon-icon-car"
      dangerouslySetInnerHTML={{
        __html: `
          <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
           width="125.000000pt" height="61.000000pt" viewBox="0 0 125.000000 61.000000"
           preserveAspectRatio="xMidYMid meet">
            <g transform="translate(0.000000,61.000000) scale(0.100000,-0.100000)"
            fill="#000000" stroke="none">
            <path d="M475 595 c-41 -15 -61 -34 -132 -128 -38 -51 -45 -55 -93 -62 -77
            -11 -199 -42 -215 -55 -21 -17 -35 -76 -35 -142 0 -63 13 -78 67 -78 53 0 70
            -10 82 -49 13 -45 35 -66 77 -74 66 -13 134 31 134 87 0 31 37 36 258 36 l220
            0 6 -35 c4 -19 17 -47 30 -62 20 -23 31 -27 74 -27 62 0 96 26 109 83 8 32 13
            37 48 43 133 23 128 21 137 53 12 43 -1 144 -22 165 -9 9 -40 20 -71 23 -42 5
            -59 12 -77 34 -153 181 -154 182 -314 193 -170 13 -236 12 -283 -5z m418 -44
            c35 -21 113 -100 157 -159 21 -28 33 -34 83 -41 32 -4 63 -13 70 -20 6 -6 13
            -43 15 -81 5 -78 11 -72 -98 -89 -39 -7 -56 -6 -59 2 -2 7 -19 27 -38 46 -30
            30 -38 33 -74 28 -46 -6 -89 -31 -96 -56 -4 -16 -28 -18 -246 -24 -185 -5
            -243 -3 -246 6 -2 7 -19 27 -38 46 -30 30 -38 33 -74 28 -50 -7 -87 -30 -100
            -64 -8 -23 -13 -25 -47 -19 -20 3 -45 6 -54 6 -15 0 -18 10 -18 60 0 56 2 60
            25 65 14 3 37 8 52 11 36 7 53 22 53 45 0 20 51 39 106 39 39 0 53 11 117 95
            79 105 87 108 299 102 157 -5 181 -7 211 -26z m-763 -210 c0 -13 -9 -17 -53
            -25 -28 -5 -37 -4 -32 4 14 23 85 40 85 21z m165 -137 c20 -8 45 -56 45 -86 0
            -13 -9 -38 -20 -55 -17 -29 -25 -33 -64 -33 -57 0 -86 32 -86 96 0 34 5 47 26
            63 26 21 67 27 99 15z m700 0 c20 -8 45 -56 45 -86 0 -13 -9 -38 -20 -55 -17
            -29 -25 -33 -64 -33 -57 0 -86 32 -86 96 0 34 5 47 26 63 26 21 67 27 99 15z"/>
            <path d="M440 502 c-45 -47 -86 -109 -78 -118 2 -2 68 -5 146 -8 l142 -5 39
            82 c22 45 38 83 37 84 -1 2 -55 6 -120 9 l-117 7 -49 -51z m222 -43 c-21 -49
            -30 -59 -49 -59 l-24 0 20 29 c25 34 27 49 6 31 -20 -17 -19 -1 2 22 9 10 14
            20 11 23 -2 2 -24 -20 -49 -50 l-44 -54 -67 -1 c-38 0 -68 3 -68 6 0 13 71
            102 86 108 33 13 35 5 9 -30 -15 -19 -25 -38 -22 -40 3 -3 20 14 38 38 l32 43
            73 -3 72 -4 -26 -59z m-74 -38 c-7 -12 -19 -21 -27 -21 -10 0 -7 8 9 25 27 29
            37 27 18 -4z"/>
            <path d="M767 523 c-33 -54 -67 -125 -67 -141 0 -11 7 -23 16 -26 27 -11 272
            -7 279 4 7 11 -104 137 -139 157 -23 14 -82 17 -89 6z m91 -39 l22 -15 -32
            -44 c-30 -40 -37 -44 -75 -45 -52 0 -53 7 -12 78 32 57 43 60 97 26z m68 -66
            l27 -33 -31 -3 c-18 -2 -45 -2 -62 0 l-30 3 26 33 c14 17 29 32 34 32 4 0 21
            -15 36 -32z"/>
            <path d="M492 318 c8 -24 118 -22 118 2 0 6 -27 10 -61 10 -44 0 -60 -3 -57
            -12z m81 -5 c-13 -2 -33 -2 -45 0 -13 2 -3 4 22 4 25 0 35 -2 23 -4z"/>
            <path d="M196 164 c-33 -32 -4 -104 42 -104 29 0 62 29 62 56 0 51 -69 84
            -104 48z m62 -16 c17 -17 15 -55 -4 -62 -22 -8 -44 11 -44 39 0 35 24 47 48
            23z"/>
            <path d="M906 164 c-33 -32 -4 -104 42 -104 29 0 62 29 62 56 0 51 -69 84
            -104 48z m62 -16 c17 -17 15 -55 -4 -62 -22 -8 -44 11 -44 39 0 35 24 47 48
            23z"/>
            </g>
          </svg>
        `,
      }}
    />
  )
}
